import CommentsSection from "./CommentsSection";
import RatingSection from "./RatingSection";
import VisitKindBox from "./VisitKindBox";

const ReviewsSection = ({ doctor }) => {
  
  if (!doctor) return <p>در حال بارگذاری...</p>;

  // استخراج اولین زمان آزاد برای هر نوع سرویس
  const appointmentService =
  doctor.service_list.find(s =>s.type === "appointment")

  const onlineService =
  doctor.service_list.find(s => s.type === "online_visit")

  return (
    <div className="xl:w-2/5 flex flex-col gap-5
    rounded-[15px] ">
        <VisitKindBox
        doctor={doctor}
        />
      <RatingSection doctor={doctor} />
      <CommentsSection doctor={doctor} />
    </div>
  );
};

export default ReviewsSection;
